// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4eedcf6c","453":"e315f390","732":"84874935"}[chunkId] + ".chunk.js";
};